import { useQuery } from '@tanstack/react-query'
import API from '../../../utils/api'

// {
//   "available": 202046,
//   "unavailable": 41008,
//   "hours": 49
// }
export const useCashoutAvailable = () => {
  const { data, isLoading, refetch } = useQuery(['/cashouts/available'], API.fetchAvailableCashout)

  return {
    data: getRealAmount(data?.data),
    isLoading,
    refetch
  }
}


const getRealAmount = (data) => {
  if (!data) return {}

  return {
    available: data.available / 100,
    unavailable: data.unavailable / 100,
    hours: data.hours
  }
}